import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterModule]
})
export class PopupComponent {
    constructor(
        private readonly _router: Router,
        @Inject(MAT_DIALOG_DATA) private readonly data?: { signUp?: boolean }
    ) {
        const path = this.data?.signUp ? 'sign-up' : 'sign-in';
        this._router.navigate([{ outlets: { auth: [path] } }], {
            skipLocationChange: true
        });
    }
}
